<template>
  <section>
    <icon name="circle-o-notch" class="fa-spin" scale="2"></icon>&nbsp;{{ $t('message.text.loading') }}
  </section>
</template>

<script>
  import 'vue-awesome/icons'
  import Icon from 'vue-awesome/components/Icon.vue'

  export default {
    components: { Icon }
  }
</script>



// WEBPACK FOOTER //
// LoadingSpinner.vue?4acab9f8